import { FormGroup } from '@angular/forms';

export abstract class AbstractForm {
    readonly initialValue;
    constructor(protected formGroup: FormGroup) {
        this.initialValue = formGroup.value;
    }

    get asFormGroup() {
        return this.formGroup;
    }

    get isValid(): boolean {
        return this.formGroup.valid;
    }

    get isPristine(): boolean {
        return this.formGroup.pristine;
    }

    get isDisabled(): boolean {
        return this.formGroup.disabled;
    }

    public createForm() {}

    disable() {
        this.formGroup.disable({ emitEvent: false });
    }
    enable() {
        this.formGroup.enable();
    }
    reset() {
        this.formGroup.reset();
    }
}
